import { array, arrayOf, bool, shape, string } from "prop-types";
import { baseDatabaseModelType } from "./baseDatabaseModel";

/** @deprecated use TypeScript interface or type instead */
export const projectMilestoneTemplateType = shape({
  ...baseDatabaseModelType,
  abbreviation: string,
  id: string,
  name: string,
  milestoneTemplateId: string,
  notificationsRequired: bool,
  documentsRequired: bool,
  childMilestones: array,
  notificationGroups: array,
  defaultFOr: arrayOf(string),
  canBeAdded: arrayOf(string),
  canBeDeleted: arrayOf(string),
  canBeSkipped: arrayOf(string),
  approvalRequired: arrayOf(string),
  partitionKey: string,
  isActive: bool,
});
